<template>
	<section class="small-12 columns freeToInvest" v-if="future_item">
		<div class="small-12 columns widget">
			<div class="small-12 wrap widgetChart borderRadius20">
				<div class="small-12 large-6 columns operationalBreakdown">
					<div class="small-12 widgetTitle flex vertical-align">
						<h2 class="small-12 flex vertical-align">
							Operational Breakdown 
							<span class="flex vertical-align">This Month</span>
						</h2>
					</div>
					<div class="small-12 stats">
						<ul class="small-12 flex">
							<li class="small-12 flex vertical-align">
								<div class="small-12 large-6">
									<p>Money In:</p>
								</div>
								<div class="small-12 large-6 flex vertical-align">
									<i class="material-icons outlined">attach_money</i>
									<span>100,000.00</span>
								</div>
							</li>
							<li class="small-12 flex vertical-align">
								<div class="small-12 large-6">
									<p>Money Out:</p>
								</div>
								<div class="small-12 large-6 flex vertical-align">
									<i class="material-icons outlined cRed">money_off</i>
									<span class="cRed">100,000.00</span>
								</div>
							</li>
							<li class="small-12 border-top flex vertical-align">
								<div class="small-12 large-6">
									<p>Net Income:</p>
								</div>
								<div class="small-12 large-6 flex vertical-align">
									<i class="material-icons outlined">attach_money</i>
									<span>2,176,500</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="small-12 large-6 columns flex vertical-align">
					<div class="small-12 balance">
						<p class="small-12 flex">Free-to-Invest</p>
						<h2 class="small-12 flex">
							<i class="material-icons-outlined">attach_money</i>
							72,343.91
						</h2>
					</div>
					<div class="small-12 stackedBarGauge">
						<ul class="flex vertical-align freeToInvestBreakdownChart borderRadius50">
							<li class="properties bgPrimaryBlue" style="width:30%;" v-tooltip="'Properties: $16,240'"></li>
							<li class="accounts bgPrimaryBlueLight" style="width:20%;" v-tooltip="'Accounts: $16,240'"></li>
							<li class="goals bgPrimaryBlueDark" style="width:10%;" v-tooltip="'Goals: $16,240'"></li>
							<li class="expenses bgSecondaryPurple" style="width:30%;" v-tooltip="'Expenses: $-16,240'"></li>
							<li class="activities bgSecondaryPurpleLight" style="width:10%;" v-tooltip="'Activities: $-16,240'"></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'FreeToInvest',

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false

		})

	}

</script>